module.exports = __webpack_public_path__ + "images/icons_v2/close-1c72a93f.svg";